import { ToggleGroup, ToggleGroupItem } from '@repo/ui/components'
import { LucideIcon } from 'lucide-react'
import { Container } from './Container'

type ToggleListProps = {
  name: string
  title: string
  options: { value: string; label: string; icon?: LucideIcon }[]
  selectedOption: string
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>
  resetValue?: string
  /**
   * Called instead of writing the default value back, for a consumer whose setter cannot take an empty
   * write — a single-select panel that treats an emptying click as a no-op would otherwise swallow a
   * reset to no selection at all.
   */
  onReset?: () => void
}

export default function SingleToggleList(props: ToggleListProps) {
  const hasOptionSelected = !!props.selectedOption

  const handleReset = () => {
    if (props.onReset) return props.onReset()

    props.setSelectedOption(props.resetValue ?? '')
  }

  return (
    <Container
      isResetVisible={props.selectedOption !== (props.resetValue ?? '')}
      onReset={handleReset}
      hasOptionsSelected={hasOptionSelected}
      title={props.title}
    >
      <ToggleGroup
        type="single"
        value={props.selectedOption}
        onValueChange={props.setSelectedOption}
        className="flex flex-wrap justify-start gap-2"
      >
        {props.options.map((option) => (
          <ToggleGroupItem key={option.value} value={option.value} variant="outline">
            {option.icon && <option.icon />}
            {option.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </Container>
  )
}
